export const GET_USERS = 'GET_USERS'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'

export const GET_USER_BY_ID = 'GET_USER_BY_ID'
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS'

export const CREATE_USER = 'CREATE_USER'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'

export const UPDATE_USER_BY_ID = 'UPDATE_USER_BY_ID'
export const UPDATE_USER_BY_ID_SUCCESS = 'UPDATE_USER_BY_ID_SUCCESS'

export const USERS_SET_FILTER_CLIENT = 'USERS_SET_FILTER_CLIENT'
export const USERS_SET_FILTER_STATUS = 'USERS_SET_FILTER_STATUS'
export const USERS_SET_FILTER_ROLE = 'USERS_SET_FILTER_ROLE'

export const USERS_SET_SORT_BY = 'USERS_SET_SORT_BY'

export const USERS_UPDATE_LOGGED_IN_USER = 'USERS_UPDATE_LOGGED_IN_USER'

export const USER_DELETE = 'USER_DELETE'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE'

export const USER_STATUSES = {
  pending: 0,
  active: 1,
  blocked: 2,
}

export const CLIENTS_FILTER_OPTIONS = [{ label: 'All', value: null }]

export const USER_STATUS_OPTIONS = [
  {
    value: null,
    label: 'All',
  },
  {
    value: 'pending',
    label: 'Pending',
  },
  {
    value: 'active',
    label: 'Active',
  },
]
